import {createAction, props} from '@ngrx/store';
import {Roles} from '../../../enum/roles';
import {Permissions} from '../../../enum/permissions';

export const updateAuthentication = createAction(
  '[AUTHENTICATION] Update authentication',
  props<{ isAuthenticated: boolean }>(),
);

export const updateUserRoles = createAction(
  '[AUTHENTICATION] Update user roles',
  props<{ roles: Roles[] }>(),
);

export const login = createAction(
  '[AUTHENTICATION] Login ',
  props<{ isAuthenticated: boolean, roles: Roles[], permissions: Permissions[] }>(),
);

export const logout = createAction(
  '[AUTHENTICATION] Logout',
  props<{ isAuthenticated: boolean, roles: Roles[] }>(),
);


